import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Tekstomrade, { createDynamicHighlightingRule, HighlightRule, BoldRule } from "./../";
export const _frontmatter = {
  "ingress": "Tekstområde er en ren teknisk komponent som lar utviklere parse tekst (strings), og automatisk rendre HTML-markup med f.eks. avsnitt og lenker."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#standard-bruk"
          }}>{`Standard bruk`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#avansert-bruk"
          }}>{`Avansert bruk`}</a></li></ol></nav>
    <h2 {...{
      "id": "standard-bruk"
    }}>{`Standard bruk`}</h2>
    <p>{`Standard oppsettet håndterer avsnitt, linjeskift og lenker.
Komponent har som mål at struktur av tekst visuelt beholdes, dvs linjeskift i input-teksten ivaretas av komponenten.`}</p>
    <Example mdxType="Example">
  <Tekstomrade mdxType="Tekstomrade">
    {`En komponent som tar ansvar for å brekke opp \ntekst i avsnitt, og \nlegge til lenker.\n\nVi kan f.eks lenke til www.nav.no, og ha flere lenker på samme linje. (Les mer her; https://nav.no)`}
  </Tekstomrade>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tekstomrade>
  {\`En komponent som tar ansvar for å brekke opp \\ntekst i avsnitt, og \\nlegge til lenker.\\n\\nVi kan f.eks lenke til www.nav.no, og ha flere lenker på samme linje. (Les mer her; https://nav.no)\`}
</Tekstomrade>
`}</code></pre>
    <h2 {...{
      "id": "avansert-bruk"
    }}>{`Avansert bruk`}</h2>
    <p>{`Komponenten er regel-basert, og åpner opp for at konsumenter kan lage sine egne rendering-regler ved behov.
For å endre reglene som er aktive kan man sende inn en liste av regler man ønsker via `}<inlineCode parentName="p">{`rules`}</inlineCode>{`-propen.`}</p>
    <Example mdxType="Example">
  <Tekstomrade rules={[HighlightRule, BoldRule, createDynamicHighlightingRule(["ruk"])]} mdxType="Tekstomrade">
    {`*Vi* kan bruke helt egne regler _her_`}
  </Tekstomrade>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import Tekstomrade, {
  createDynamicHighlightingRule,
  HighlightRule,
  BoldRule,
} from "nav-frontend-tekstomrade";

<Tekstomrade
  rules={[HighlightRule, BoldRule, createDynamicHighlightingRule(["ruk"])]}
>
  {\`*Vi* kan bruke helt egne regler _her_\`}
</Tekstomrade>;
`}</code></pre>
    <p>{`Komponenten kommer med ett sett av ferdig-implementerte regler;`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`LinebreakRule`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`ParagraphRule`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`HighlightRule`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`createDynamicHighlightingRule`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`BoldRule`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`LinkRule`}</inlineCode></li>
    </ul>
    <p>{`For dokumentasjon av regel-utvikling se `}<a parentName="p" {...{
        "href": "https://github.com/navikt/textparser"
      }}>{`parser biblioteket`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      